// Form fields configuration with labels, placeholders, icons, types, and names
import Company from "assets/icons/Company.svg";
import PhoneCall from "assets/icons/PhoneCall.svg";
import Email from "assets/icons/Email.svg";
import Location from "assets/icons/Location.svg";
import FileIcon from "assets/icons/FileIcon.svg";
import Tools from "assets/icons/Tools.svg";
import House from "assets/icons/House.svg";
import Calendar from "assets/icons/Calendar.svg";
import Star from "assets/icons/Star.svg";
import Help from "assets/icons/Help.svg";
import BriefCase from "assets/icons/BriefCase.svg";
import UserCircle from "assets/icons/UserCircle.svg";
import Lock from "assets/icons/LockedOut.svg";
import Alert from "assets/icons/Alert.svg";
import Message from "assets/icons/Message.svg";
import Search from "assets/icons/Search.svg";
import * as Yup from "yup";

export const formFields = {
  step1: {
    fullName: {
      label: "Full Name",
      placeholder: "Enter your full name",
      startIcon: UserCircle,
      type: "text",
      name: "fullName",
    },
    phone_number: {
      label: "Phone Number",
      placeholder: "(123) 456-7890",
      startIcon: PhoneCall,
      type: "tel",
      name: "phone_number",
      mask: "(999) 999-9999",
      maskChar: "",
    },
    email: {
      label: "Email Address",
      placeholder: "Enter your email address",
      startIcon: Email,
      type: "email",
      name: "email",
    },
  },
  step2: {
    company_name: {
      label: "Company Name",
      placeholder: "Enter your company name",
      startIcon: Company,
      type: "text",
      name: "company_name",
    },
    business_address: {
      label: "Business Address (Line 1)",
      placeholder: "e.g. 123 Main St",
      startIcon: Location,
      type: "text",
      name: "business_address",
    },
    business_city: {
      label: "City",
      placeholder: "e.g. Los Angeles",
      startIcon: Location,
      type: "text",
      name: "business_city",
    },
    business_state: {
      label: "State",
      placeholder: "e.g. CA",
      startIcon: Location,
      type: "text",
      name: "business_state",
    },
    business_zip: {
      label: "Zip Code",
      placeholder: "e.g. 90001",
      startIcon: Location,
      type: "text",
      name: "business_zip",
    },
    service_category_ids: {
      label: "Service Categories",
      placeholder: "Select categories",
      startIcon: Search,
      type: "multiselect",
      name: "service_category_ids",
      options: [], // options provided dynamically from backend
    },
    county_ids: {
      label: "Select counties you serve:",
      placeholder: "Select serving counties",
      startIcon: Location,
      type: "checkbox",
      name: "county_ids",
      options: [], // options provided dynamically from backend
    },
    year_started: {
      label: "Year Started",
      placeholder: "e.g. 2010",
      startIcon: Calendar,
      type: "number",
      name: "year_started",
    },
    years_under_present_name: {
      label: "How many years under present name?",
      placeholder: "e.g. 5",
      startIcon: Calendar,
      type: "number",
      name: "years_under_present_name",
    },
    operated_under_other_names: {
      label: "Has the business ever operated under other names?",
      placeholder: "Select yes or no",
      startIcon: Help,
      type: "radio",
      name: "operated_under_other_names",
      options: [
        { value: "yes", label: "Yes" },
        { value: "no", label: "No" },
      ],
    },
    prior_names: {
      label: "If yes, list prior names:",
      placeholder: "List any prior names",
      startIcon: Message,
      type: "textarea",
      name: "prior_names",
    },
    organization_type: {
      label: "Type of Organization",
      placeholder: "Select type",
      startIcon: BriefCase,
      type: "select",
      name: "organization_type",
      options: [
        { value: "SOLE_PROPRIETORSHIP", label: "Sole Proprietorship" },
        { value: "PARTNERSHIP", label: "Partnership" },
        { value: "CORPORATION", label: "Corporation" },
        { value: "LLC", label: "Limited Liability Company (LLC)" },
        { value: "OTHER", label: "Other" },
      ],
    },
    organization_state: {
      label: "State of Organization",
      placeholder: "e.g. Delaware",
      startIcon: Location,
      type: "text",
      name: "organization_state",
    },
    organization_other_description: {
      label: "Describe Organization Type",
      placeholder: "Please describe...",
      startIcon: Message,
      type: "textarea",
      name: "organization_other_description",
    },
    partnership_type: {
      label: "If Partnership, what type?",
      placeholder: "Select type",
      startIcon: BriefCase,
      type: "select",
      name: "partnership_type",
      options: [
        { value: "GENERAL", label: "General" },
        { value: "LIMITED", label: "Limited" },
        { value: "LLP", label: "Limited Liability Partnership (LLP)" },
      ],
    },
    business_website: {
      label: "Business Website",
      placeholder: "https://www.example.com",
      startIcon: Search,
      type: "url",
      name: "business_website",
    },
    main_phone: {
      label: "Main Business Phone",
      placeholder: "(123) 456-7890",
      startIcon: PhoneCall,
      type: "tel",
      name: "main_phone",
      mask: "(999) 999-9999",
      maskChar: "",
    },
    main_fax: {
      label: "Main Business Fax",
      placeholder: "(123) 456-7890",
      startIcon: PhoneCall,
      type: "tel",
      name: "main_fax",
      mask: "(999) 999-9999",
      maskChar: "",
    },
    ownership_changes_past_year: {
      label: "Any ownership changes in the past year?",
      placeholder: "Select yes or no",
      startIcon: Help,
      type: "radio",
      name: "ownership_changes_past_year",
      options: [
        { value: "yes", label: "Yes" },
        { value: "no", label: "No" },
      ],
    },
    ownership_changes_details: {
      label: "If yes, provide details:",
      placeholder: "Provide details of ownership changes",
      startIcon: Message,
      type: "textarea",
      name: "ownership_changes_details",
    },
  },
  step3: {
    // emergency_24_7: {
    //   label: "24/7 Emergency Availability:",
    //   placeholder: "Select 24/7 Emergency Availability",
    //   startIcon: House,
    //   type: "toggle",
    //   name: "emergency_24_7",
    // },
  },
  step4: {
    business_contact_name: {
      label: "Business Contact Name",
      placeholder: "Enter name",
      startIcon: UserCircle,
      type: "text",
      name: "business_contact_name",
    },
    business_contact_email: {
      label: "Business Contact Email",
      placeholder: "Enter email",
      startIcon: Email,
      type: "email",
      name: "business_contact_email",
    },
    business_contact_phone: {
      label: "Business Contact Phone",
      placeholder: "(123) 456-7890",
      startIcon: PhoneCall,
      type: "tel",
      name: "business_contact_phone",
      mask: "(999) 999-9999",
      maskChar: "",
    },
    insurance_contact_name: {
      label: "Insurance Contact Name",
      placeholder: "Enter name",
      startIcon: UserCircle,
      type: "text",
      name: "insurance_contact_name",
    },
    insurance_contact_email: {
      label: "Insurance Contact Email",
      placeholder: "Enter email",
      startIcon: Email,
      type: "email",
      name: "insurance_contact_email",
    },
    insurance_contact_phone: {
      label: "Insurance Contact Phone",
      placeholder: "(123) 456-7890",
      startIcon: PhoneCall,
      type: "tel",
      name: "insurance_contact_phone",
      mask: "(999) 999-9999",
      maskChar: "",
    },
    accounting_contact_name: {
      label: "Accounting Contact Name",
      placeholder: "Enter name",
      startIcon: UserCircle,
      type: "text",
      name: "accounting_contact_name",
    },
    accounting_contact_email: {
      label: "Accounting Contact Email",
      placeholder: "Enter email",
      startIcon: Email,
      type: "email",
      name: "accounting_contact_email",
    },
    accounting_contact_phone: {
      label: "Accounting Contact Phone",
      placeholder: "(123) 456-7890",
      startIcon: PhoneCall,
      type: "tel",
      name: "accounting_contact_phone",
      mask: "(999) 999-9999",
      maskChar: "",
    },
  },
  step6: {
    // businessDuration: {
    //   label: "How long have you been in business?",
    //   placeholder: "Select options",
    //   startIcon: Calendar,
    //   type: "select",
    //   name: "businessDuration",
    //   options: [
    //     { value: "less_than_1_year", label: "Less than 1 year" },
    //     { value: "1_2_years", label: "1-2 years" },
    //     { value: "3_5_years", label: "3-5 years" },
    //     { value: "6_10_years", label: "6-10 years" },
    //     { value: "more_than_10_years", label: "More than 10 years" },
    //   ],
    // },
  }, // Stripe Step
  step7: {
    is_bonded: {
      label: "Is the business bonded?",
      placeholder: "Select yes or no",
      startIcon: Help,
      type: "radio",
      name: "is_bonded",
      options: [
        { value: "yes", label: "Yes" },
        { value: "no", label: "No" },
      ],
    },
    bond_amount: {
      label: "Bond Amount",
      placeholder: "e.g. $50,000",
      startIcon: BriefCase,
      type: "text",
      name: "bond_amount",
    },
    bond_expiration_date: {
      label: "Bond Expiration Date",
      placeholder: "Select date",
      startIcon: Calendar,
      type: "date",
      name: "bond_expiration_date",
    },
    safety_violations_past_5_years: {
      label: "Any safety violations in the past 5 years?",
      placeholder: "Select yes or no",
      startIcon: Help,
      type: "radio",
      name: "safety_violations_past_5_years",
      options: [
        { value: "yes", label: "Yes" },
        { value: "no", label: "No" },
      ],
    },
    safety_violations_details: {
      label: "If yes, provide details:",
      placeholder: "Provide details of safety violations",
      startIcon: Message,
      type: "textarea",
      name: "safety_violations_details",
    },
    pending_claims_suits: {
      label: "Any pending claims or suits against the business?",
      placeholder: "Select yes or no",
      startIcon: Help,
      type: "radio",
      name: "pending_claims_suits",
      options: [
        { value: "yes", label: "Yes" },
        { value: "no", label: "No" },
      ],
    },
    pending_claims_suits_details: {
      label: "If yes, provide details:",
      placeholder: "Provide details of pending claims or suits",
      startIcon: Message,
      type: "textarea",
      name: "pending_claims_suits_details",
    },
    felony_convictions: {
      label: "Any felony convictions for owners or officers?",
      placeholder: "Select yes or no",
      startIcon: Help,
      type: "radio",
      name: "felony_convictions",
      options: [
        { value: "yes", label: "Yes" },
        { value: "no", label: "No" },
      ],
    },
    felony_convictions_details: {
      label: "If yes, provide details:",
      placeholder: "Provide details of felony convictions",
      startIcon: Message,
      type: "textarea",
      name: "felony_convictions_details",
    },
    // max_project_size: {
    //   label: "What is your largest project size handled?",
    //   placeholder: "e.g. $100,000",
    //   startIcon: BriefCase,
    //   type: "text",
    //   name: "max_project_size",
    // },
    // total_annual_volume: {
    //   label: "Total Annual Business Volume",
    //   placeholder: "e.g. $1,000,000",
    //   startIcon: BriefCase,
    //   type: "text",
    //   name: "total_annual_volume",
    // },
    // number_of_employees: {
    //   label: "Number of Employees",
    //   placeholder: "e.g. 10",
    //   startIcon: UserCircle,
    //   type: "number",
    //   name: "number_of_employees",
    // },
    certifications: {
      label: "Certifications",
      placeholder: "List any certifications (e.g. LEED, EPA, etc.)",
      startIcon: Star,
      type: "textarea",
      name: "certifications",
    },
    offers_warranty: {
      label: "Do you offer a warranty period? ",
      placeholder: "Select yes or no",
      startIcon: Help,
      type: "radio",
      name: "offers_warranty",
      options: [
        { value: "yes", label: "Yes" },
        { value: "no", label: "No" },
      ],
    },
    warranty_duration_text: {
      label: "If yes, How long?",
      placeholder: "Mandatory if yes...",
      startIcon: Calendar,
      type: "textarea",
      name: "warranty_duration_text",
    },
    // w9_file: {
    //   label: "Upload W-9 Tax Form:",
    //   placeholder: "Upload W-9 document",
    //   startIcon: FileIcon,
    //   type: "file",
    //   name: "w9_file",
    //   accept: "image/*,.pdf,.doc,.docx",
    // },
  },
};
export const Title = {
  0: {
    title: "Basic Contact Info",
    subTitle: "Help us set up your account",
  },
  1: {
    title: "Business Details",
    subTitle: "Tell us more about your business",
  },
  2: {
    title: "Key Contacts",
    subTitle: "Let us know who to contact within your company regarding business matters, insurance matters and accounting matters",
  },
  3: {
    title: "Licensing and Insurance",
    subTitle: "Upload your Credentials",
  },
  4: {
    title: "Stripe Setup",
    subTitle: "We use Stripe to securely collect your payout details. You'll be redirected to Stripe to finish setup and then come back here.",
  },
  5: {
    title: "References",
    subTitle: "Provide your past work history.",
  },
  6: {
    title: "Business History",
    subTitle: "Is there anything else we need to know?",
  },
  7: {
    title: "Thank You for Completing Your Vendor Application",
    subTitle:
      "Your application has been submitted and is now under review. Our team will reach out soon to schedule your onboarding meeting.",
  },
};

export const initialValues = {
  // Step 1
  fullName: "",
  phone_number: "",
  email: "",

  // Step 2
  company_name: "",
  business_address: "",
  business_city: "",
  business_state: "",
  business_zip: "",
  service_category_ids: [],
  county_ids: [],
  year_started: "",
  years_under_present_name: "",
  operated_under_other_names: "",
  prior_names: "",
  organization_type: "",
  organization_state: "",
  organization_other_description: "",
  partnership_type: "",
  business_website: "",
  main_phone: "",
  main_fax: "",
  ownership_changes_past_year: "",
  ownership_changes_details: "",

  // Step 3
  business_contact_name: "",
  business_contact_email: "",
  business_contact_phone: "",
  insurance_contact_name: "",
  insurance_contact_email: "",
  insurance_contact_phone: "",
  accounting_contact_name: "",
  accounting_contact_email: "",
  accounting_contact_phone: "",
  same_as_business_insurance: false,
  same_as_business_accounting: false,
  // emergency_24_7: false,

  // Step 4
  licenses: [],
  insurances: [],

  // Step 5 (Stripe)
  stripe_onboarding_complete: false,
  stripe_ready: false,
  stripe_onboarding_status: "",

  // Step 6 (References)
  businessDuration: "",
  references: [],

  // Step 7 (Business History)
  is_bonded: "",
  bond_amount: "",
  bond_expiration_date: "",
  safety_violations_past_5_years: "",
  safety_violations_details: "",
  pending_claims_suits: "",
  pending_claims_suits_details: "",
  felony_convictions: "",
  felony_convictions_details: "",
  // max_project_size: "",
  // total_annual_volume: "",
  // number_of_employees: "",
  certifications: "",
  offers_warranty: "",
  warranty_duration_text: "",
  // w9_file: null,
};

// Validation schemas for each step
export const validationSchemas = {
  0: Yup.object().shape({
    fullName: Yup.string().nullable().optional(),
    phone_number: Yup.string()
      .nullable()
      .optional()
      .test("validPhone", "Please enter a valid phone number", (value) => {
        if (!value) return true;
        const digits = String(value).replace(/\D/g, "");
        return digits.length === 10;
      }),
    email: Yup.string().email("Invalid email").nullable().optional(),
  }),

  1: Yup.object().shape({
    company_name: Yup.string().nullable().optional(),
    business_address: Yup.string()
      .max(200, "Address must not exceed 200 characters")
      .nullable()
      .optional(),
    business_city: Yup.string().nullable().optional(),
    business_state: Yup.string().nullable().optional(),
    business_zip: Yup.string().nullable().optional(),
    service_category_ids: Yup.array().optional(),
    county_ids: Yup.array().optional(),
    year_started: Yup.number()
      .typeError("Must be a number")
      .nullable()
      .optional()
      .min(1800, "Invalid year")
      .max(new Date().getFullYear(), "Year cannot be in the future"),
    years_under_present_name: Yup.number()
      .typeError("Must be a number")
      .nullable()
      .optional()
      .min(0, "Cannot be negative"),
    operated_under_other_names: Yup.string().nullable().optional(),
    prior_names: Yup.string().nullable().optional(),
    organization_type: Yup.string().nullable().optional(),
    organization_state: Yup.string().nullable().optional(),
    organization_other_description: Yup.string().nullable().optional(),
    partnership_type: Yup.string().nullable().optional(),
    business_website: Yup.string()
      .transform((value) => (value === "" ? null : value))
      .url("Must be a valid URL (include http:// or https://)")
      .nullable()
      .optional(),
    main_phone: Yup.string()
      .nullable()
      .optional()
      .test("validPhone", "Please enter a valid phone number", (value) => {
        if (!value) return true;
        const digits = String(value).replace(/\D/g, "");
        return digits.length === 10;
      }),
    main_fax: Yup.string()
      .nullable()
      .optional()
      .test("validFax", "Please enter a valid fax number", (value) => {
        if (!value) return true;
        const digits = String(value).replace(/\D/g, "");
        return digits.length === 10;
      }),
    ownership_changes_past_year: Yup.string().nullable().optional(),
    ownership_changes_details: Yup.string().nullable().optional(),
  }),

  2: Yup.object().shape({
    business_contact_name: Yup.string().nullable().optional(),
    business_contact_email: Yup.string()
      .email("Invalid email")
      .nullable()
      .optional(),
    business_contact_phone: Yup.string()
      .nullable()
      .optional()
      .test("validPhone", "Please enter a valid phone number", (value) => {
        if (!value) return true;
        const digits = String(value).replace(/\D/g, "");
        return digits.length === 10;
      }),
    insurance_contact_name: Yup.string().nullable().optional(),
    insurance_contact_email: Yup.string()
      .email("Invalid email")
      .nullable()
      .optional(),
    insurance_contact_phone: Yup.string()
      .nullable()
      .optional()
      .test("validPhone", "Please enter a valid phone number", (value) => {
        if (!value) return true;
        const digits = String(value).replace(/\D/g, "");
        return digits.length === 10;
      }),
    accounting_contact_name: Yup.string().nullable().optional(),
    accounting_contact_email: Yup.string()
      .email("Invalid email")
      .nullable()
      .optional(),
    accounting_contact_phone: Yup.string()
      .nullable()
      .optional()
      .test("validPhone", "Please enter a valid phone number", (value) => {
        if (!value) return true;
        const digits = String(value).replace(/\D/g, "");
        return digits.length === 10;
      }),
  }),

  3: Yup.object().shape({
    licenses: Yup.array().of(
      Yup.object().shape({
        license_name: Yup.string().nullable().optional(),
        issuing_authority: Yup.string().nullable().optional(),
        jurisdiction_coverage: Yup.string().nullable().optional(),
        license_number: Yup.string().nullable().optional(),
        license_document: Yup.mixed().nullable(),
        expiration_date: Yup.date().nullable().optional(),
      })
    ),
    insurances: Yup.array().of(
      Yup.object().shape({
        insurance_document: Yup.mixed().nullable(),
      })
    ),
  }),

  4: Yup.object().shape({
    stripe_onboarding_complete: Yup.boolean().oneOf(
      [true],
      "Please complete Stripe setup to continue"
    ),
  }),

  5: Yup.object().shape({
    references: Yup.array().of(
      Yup.object().shape({
        first_name: Yup.string().nullable().optional(),
        last_name: Yup.string().nullable().optional(),
        email: Yup.string()
          .email("Invalid email format")
          .optional()
          .nullable(),
        phone: Yup.string()
          .nullable()
          .optional()
          .test("validPhone", "Please enter a valid phone number", (value) => {
            if (!value) return true;
            const digits = String(value).replace(/\D/g, "");
            return digits.length === 10;
          }),
      })
    ),
  }),

  6: Yup.object().shape({
    is_bonded: Yup.string().nullable().optional(),
    bond_amount: Yup.string().nullable().optional(),
    bond_expiration_date: Yup.date().nullable().optional(),
    safety_violations_past_5_years: Yup.string().nullable().optional(),
    safety_violations_details: Yup.string().nullable().optional(),
    pending_claims_suits: Yup.string().nullable().optional(),
    pending_claims_suits_details: Yup.string().nullable().optional(),
    felony_convictions: Yup.string().nullable().optional(),
    felony_convictions_details: Yup.string().nullable().optional(),
    offers_warranty: Yup.string().nullable().optional(),
    warranty_duration_text: Yup.string().nullable().optional(),
    // max_project_size: Yup.string().required("Max project size is required"),
    // total_annual_volume: Yup.string().required("Total annual volume is required"),
    // number_of_employees: Yup.number()
    //   .typeError("Must be a number")
    //   .required("Number of employees is required")
    //   .min(0, "Cannot be negative"),
  }),
};

export const stepsNames = [
  "Basic Contact Info",
  "Business Details",
  "Key Contacts",
  "Licensing and Insurance",
  "Stripe Setup",
  "References",
  "Business History",
];

export const stepFieldsMap = {
  0: ["fullName", "phone_number", "email"],
  1: [
    "company_name",
    "business_address",
    "business_city",
    "business_state",
    "business_zip",
    "service_category_ids",
    "county_ids",
    "year_started",
    "years_under_present_name",
    "operated_under_other_names",
    "prior_names",
    "organization_type",
    "organization_state",
    "organization_other_description",
    "partnership_type",
    "business_website",
    "main_phone",
    "main_fax",
    "ownership_changes_past_year",
    "ownership_changes_details",
  ],
  2: [
    "business_contact_name",
    "business_contact_email",
    "business_contact_phone",
    "insurance_contact_name",
    "insurance_contact_email",
    "insurance_contact_phone",
    "accounting_contact_name",
    "accounting_contact_email",
    "accounting_contact_phone",
  ],
  3: ["licenses", "insurances"], // "emergency_24_7"
  4: ["stripe_onboarding_complete"],
  5: ["references"],
  6: [
    "is_bonded",
    "bond_amount",
    "bond_expiration_date",
    "safety_violations_past_5_years",
    "safety_violations_details",
    "pending_claims_suits",
    "pending_claims_suits_details",
    "felony_convictions",
    "felony_convictions_details",
    // "max_project_size",
    // "total_annual_volume",
    // "number_of_employees",
    "certifications",
    "offers_warranty",
    "warranty_duration_text",
    // "w9_file",
  ],
};
